import { render, staticRenderFns } from "./ChildTable.vue?vue&type=template&id=9d4fb036&scoped=true"
import script from "./ChildTable.vue?vue&type=script&lang=js"
export * from "./ChildTable.vue?vue&type=script&lang=js"
import style0 from "./ChildTable.vue?vue&type=style&index=0&id=9d4fb036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4fb036",
  null
  
)

export default component.exports